export default __webpack_public_path__ + "static/media/instaBackground.6706244b.png";